/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useRef } from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';

import avatar from '../../../../../../../assets/images/user-32-04.jpg';
import FreshcallerCallService from '../../../../../../../services/FreshcallerCallService';

export default function Message({ conversation }) {
  const [open, setOpen] = useState(true);

  const shadowDomRef = useRef(null);

  const isCall = conversation.is_call;

  const { data: callRecording } = useQuery({
    queryKey: ['callRecording', conversation.id, conversation.recording_id],
    queryFn: () =>
      FreshcallerCallService.getFreshcallerCallRecording({
        callId: conversation.id,
        recordingId: conversation.recording_id,
      }),
    enabled: !!conversation.recording_id,
  });

  useEffect(() => {
    if (shadowDomRef.current) {
      // Attach shadow if it doesn't exist
      if (!shadowDomRef.current.shadowRoot) {
        shadowDomRef.current.attachShadow({ mode: 'open' });
      }
      // Always update the innerHTML with the current conversation.body
      shadowDomRef.current.shadowRoot.innerHTML = conversation.body || '';
    }
  }, [conversation.body]);

  return (
    <div className="py-6">
      {/* Header */}
      <header className="flex items-start">
        {/* Avatar */}
        <img
          className="rounded-full shrink-0 mr-3"
          src={avatar}
          width="40"
          height="40"
          alt={conversation.name}
        />
        {/* Meta */}
        <div className="grow">
          <div className="sm:flex items-start justify-between mb-0.5">
            {/* Message author */}
            <div className="xl:flex items-center mb-2 sm:mb-0">
              <button
                type="button"
                className="text-sm font-semibold text-slate-800 dark:text-slate-100 text-left break-all"
                onClick={() => setOpen(!open)}
              >
                <span className="w-full">{conversation.from_email}</span>
              </button>
              {/* {open && (
                <>
                  <div className="text-sm text-slate-400 dark:text-slate-600 hidden xl:block mx-1">
                    ·
                  </div>
                  <div className="text-xs dark:text-slate-500">
                    {conversation.email}
                  </div>
                </>
              )} */}
            </div>
            {/* Date */}
            <div className="text-xs font-medium text-slate-500 whitespace-nowrap mb-2 sm:mb-0">
              {moment(conversation.created_at).format('MMM D, h:mm A')}
            </div>
          </div>
          {/* To */}
          {open && conversation.to_emails && (
            <div className="text-xs font-medium text-slate-500">
              To {conversation.to_emails?.join(', ')}
            </div>
          )}
          {/* Excerpt */}
          {!open && <div className="text-sm">{conversation.body_text}</div>}
        </div>
      </header>
      {/* Body */}
      {open && (
        <>
          <div
            className="text-sm text-slate-800 dark:text-slate-100 mt-4 space-y-2 overflow-y-auto"
            ref={shadowDomRef}
          />
          {/*  <div
            className="text-sm text-slate-800 dark:text-slate-100 mt-4 space-y-2 overflow-y-auto"
            dangerouslySetInnerHTML={{ __html: conversation.body }}
          /> */}
          {isCall && (
            <div>
              {conversation.recording_id ? (
                <audio className="w-full" controls src={callRecording} />
              ) : (
                <p>There is no recording available for this call</p>
              )}
              {conversation.transcript ? (
                <p className="mt-4">{conversation.transcript}</p>
              ) : (
                <p className="mt-4">There is no transcript for this call</p>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
